import React from 'react';

import { DescriptionIcon, ErrorIcon, Text } from '@thefarmersfront/kitchen';

import { CustomNoRowsOverlayProps } from 'ag-grid-react';

import { NO_ROWS_MESSAGE, TypeNoRowsStatusKey } from '~/constants';

import styles from './NoRowsOverlay.module.scss';

const NoRowsOverlay = (props: CustomNoRowsOverlayProps & { rowStatusType: TypeNoRowsStatusKey }) => {
  return (
    <div role="presentation" className={styles['no-rows-overlay']}>
      {props.rowStatusType === 'INIT' && <DescriptionIcon color="gray400" size={32} />}
      {props.rowStatusType === 'EMPTY' && <ErrorIcon color="gray400" size={32} />}
      {props.rowStatusType === 'SEARCH_EMPTY' && <ErrorIcon color="gray400" size={32} />}
      {props.rowStatusType === 'RECEIVE_REGISTER' && <ErrorIcon color="gray400" size={32} />}
      {props.rowStatusType === 'STOCK_RELEASE_REGISTER' && <DescriptionIcon color="gray400" size={32} />}
      {props.rowStatusType === 'NO_DATA' && <ErrorIcon color="gray400" size={32} />}
      {props.rowStatusType === 'DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL' && (
        <DescriptionIcon color="gray400" size={32} />
      )}
      {props.rowStatusType === 'DELIVERY_AGENCY_ADDITIONAL_SHIPPING_LABEL_PRINT' && (
        <DescriptionIcon color="gray400" size={32} />
      )}
      <Text color="disabled" size="small" weight="semi-bold">
        {NO_ROWS_MESSAGE[props.rowStatusType]}
      </Text>
    </div>
  );
};

export default NoRowsOverlay;
